import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { Action } from 'redux';

/////////////////////////////////////////////////////////////////////
// Load

export interface ContestsHomeFetchAction extends Action {
    readonly after: number; // Last item id
}
export const CONTESTS_HOME_FETCH_REQUEST = 'CONTESTS_HOME_FETCH_REQUEST';
export interface ContestsHomeFetchRequestAction
    extends ContestsHomeFetchAction,
        APIRequestAction {
    readonly type: typeof CONTESTS_HOME_FETCH_REQUEST;
}
export interface ContestsHomeFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        runningContests: number[];
        finishedContests: number[];
    };
}
export const CONTESTS_HOME_FETCH_SUCCESS = 'CONTESTS_HOME_FETCH_SUCCESS';
export interface ContestsHomeFetchSuccessAction
    extends ContestsHomeFetchAction,
        APISuccessAction<ContestsHomeFetchNormalizedResponse> {
    readonly type: typeof CONTESTS_HOME_FETCH_SUCCESS;
    readonly hasMore: boolean;
    readonly isFollowing: boolean;
    readonly hasNext: number;
    readonly hasPrevious: number;
}

export const CONTESTS_HOME_FETCH_FAILURE = 'CONTESTS_HOME_FETCH_FAILURE';
export interface ContestsHomeFetchFailureAction
    extends ContestsHomeFetchAction,
        APIFailureAction {
    readonly type: typeof CONTESTS_HOME_FETCH_FAILURE;
}

export const contestsHomeFetch = {
    request: (after: number): ContestsHomeFetchRequestAction => ({
        type: CONTESTS_HOME_FETCH_REQUEST,
        after,
    }),
    success: (
        after: number,
        hasMore: boolean,
        isFollowing: boolean,
        hasNext: number,
        hasPrevious: number,
        response: ContestsHomeFetchNormalizedResponse,
    ): ContestsHomeFetchSuccessAction => ({
        type: CONTESTS_HOME_FETCH_SUCCESS,
        after,
        hasMore,
        isFollowing,
        hasNext,
        hasPrevious,
        response,
    }),
    failure: (after: number, error: any): ContestsHomeFetchFailureAction => ({
        type: CONTESTS_HOME_FETCH_FAILURE,
        after,
        error,
    }),
};

export const CONTESTS_HOME_LOAD = 'CONTESTS_HOME_LOAD';
export interface ContestsHomeLoadAction extends ContestsHomeFetchAction {
    readonly type: typeof CONTESTS_HOME_LOAD;
}
export const contestsHomeLoad = (after?: number): ContestsHomeLoadAction => ({
    type: CONTESTS_HOME_LOAD,
    after,
});

/////////////////////////////////////////////////////////////////////
// Set/unset "following" flag

export interface ContestsHomeSetFollowingApiAction extends Action {
    readonly value: boolean;
}

export const CONTESTS_HOME_SET_FOLLOWING_API_REQUEST = 'CONTESTS_HOME_SET_FOLLOWING_API_REQUEST';

export interface ContestsHomeSetFollowingApiRequestAction extends ContestsHomeSetFollowingApiAction, APIRequestAction {
    readonly type: typeof CONTESTS_HOME_SET_FOLLOWING_API_REQUEST;
}

export const CONTESTS_HOME_SET_FOLLOWING_API_SUCCESS = 'CONTESTS_HOME_SET_FOLLOWING_API_SUCCESS';

export interface ContestsHomeSetFollowingApiSuccessAction extends ContestsHomeSetFollowingApiAction, APISuccessAction {
    readonly type: typeof CONTESTS_HOME_SET_FOLLOWING_API_SUCCESS;
}

export const CONTESTS_HOME_SET_FOLLOWING_API_FAILURE = 'CONTESTS_HOME_SET_FOLLOWING_API_FAILURE';

export interface ContestsHomeSetFollowingApiFailureAction extends ContestsHomeSetFollowingApiAction, APIFailureAction {
    readonly type: typeof CONTESTS_HOME_SET_FOLLOWING_API_FAILURE;
}

export const contestsHomeSetFollowingApi = {
    request: (value: boolean): ContestsHomeSetFollowingApiRequestAction => ({
        type: CONTESTS_HOME_SET_FOLLOWING_API_REQUEST, value,
    }),
    success: (value: boolean, response: any): ContestsHomeSetFollowingApiSuccessAction => ({
        type: CONTESTS_HOME_SET_FOLLOWING_API_SUCCESS, value, response,
    }),
    failure: (value: boolean, error: any): ContestsHomeSetFollowingApiFailureAction => ({
        type: CONTESTS_HOME_SET_FOLLOWING_API_FAILURE, value, error,
    }),
};

export const CONTESTS_HOME_SET_FOLLOWING = 'CONTESTS_HOME_SET_FOLLOWING';

export interface ContestsHomeSetFollowingAction extends ContestsHomeSetFollowingApiAction {
    readonly type: typeof CONTESTS_HOME_SET_FOLLOWING;
}

export const contestsHomeSetFollowing = (value: boolean): ContestsHomeSetFollowingAction => ({
    type: CONTESTS_HOME_SET_FOLLOWING, value,
});
